<template>
  <v-timeline-item
    dot-color="userActivity"
    icon="mdi-information-variant"
    fill-dot
  >
    <v-expansion-panels
      class="expansion-panels"
      variant="accordion"
      flat
    >
      <v-expansion-panel>
        <v-expansion-panel-title>
          <v-row
            no-gutters
            align="center"
            class="pr-2 mb-2 mt-n2 d-flex justify-center"
            :class="{ 'flex-column': $vuetify.display.smAndDown }"
          >
            <v-col md="8">
              <div class="text-subtitle-1 text-black">
                <img
                  class="logo"
                  :src="logo"
                />
              </div>
              <div class="text-subtitle-1 text-black">
                {{ $t('lead.konstantine.analysis-title') }}
              </div>
            </v-col>
            <v-col
              class="text-right text-grey text--small pr-2"
              :class="{ 'text-start mt-2': $vuetify.display.smAndDown }"
              md="4"
            >
              {{ formatDate(data.createdAt) }}
            </v-col>
          </v-row>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <v-row>
            <v-col>
              <v-list density="compact">
                <v-list-item class="px-0">
                  <v-list-item-title>
                    {{ $t('lead.konstantine.analysis-subtitle-summary') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    <span
                      v-for="(summary, index) in konstantine?.summary"
                      :key="index"
                    >
                      {{ summary }}<br />
                    </span>
                  </div>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-title>
                    {{ $t('lead.konstantine.analysis-subtitle') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ sentiment }}
                  </div>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-title>
                    {{ $t('lead.konstantine.analysis-subtitle-potential') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ potential }}
                  </div>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-title>
                    {{ $t('lead.konstantine.analysis-subtitle-interactive') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    <span v-if="konstantine?.interactive">
                      {{ interactivePositive }}
                    </span>
                    <span v-else>{{ interactiveNegative }}</span>
                  </div>
                </v-list-item>
                <v-list-item class="px-0">
                  <v-list-item-title>
                    {{ $t('lead.konstantine.analysis-subtitle-follow-up') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    <span v-if="konstantine?.followUp?.boolean">
                      {{ followUpPositive }}<br />
                      <span v-if="konstantine?.followUp?.when?.date">
                        {{ $t('lead.konstantine.analysis-subtitle-when') }}:
                        {{ formatDate(konstantine.followUp.when.date) }}
                      </span>
                    </span>
                    <span v-else>{{ followUpNegative }}</span>
                  </div>
                </v-list-item>
                <v-list-item
                  class="px-0"
                  v-if="konstantine?.followUp?.when?.date"
                >
                  <v-list-item-title>
                    {{ $t('lead.konstantine.analysis-subtitle-when') }}:
                  </v-list-item-title>
                  <div class="text-grey text--darken-3 text-body-2">
                    {{ formatDate(konstantine.followUp.when.date) }}
                  </div>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-timeline-item>
</template>

<script>
import logo from '@/assets/img/konstantine/logo.png'
export default {
  props: {
    data: { type: Object, default: null },
  },
  data() {
    return {
      logo,
    }
  },
  computed: {
    konstantine() {
      return this.data?.details?.KONSTANTINE || {}
    },
    followUpPositive() {
      return this.$t('lead.konstantine.follow-up-positive')
    },
    followUpNegative() {
      return this.$t('lead.konstantine.follow-up-negative')
    },
    interactivePositive() {
      return this.$t('lead.konstantine.interactive-positive')
    },
    interactiveNegative() {
      return this.$t('lead.konstantine.interactive-negative')
    },
    sentiment() {
      return (
        {
          negative: this.$t('lead.konstantine.sentiment-negative'),
          neutral: this.$t('lead.konstantine.sentiment-neutral'),
          positive: this.$t('lead.konstantine.sentiment-positive'),
        }[this.data?.details?.KONSTANTINE?.sentiment] || ''
      )
    },
    potential() {
      return (
        {
          1: this.$t('lead.konstantine.no-potential'),
          2: this.$t('lead.konstantine.some-potential'),
          3: this.$t('lead.konstantine.high-potential'),
        }[this.data?.details?.KONSTANTINE?.potential] || ''
      )
    },
  },
}
</script>

<style scoped>
.text--small {
  font-size: 15px;
}

.logo {
  height: 22px;
}
</style>
